import { Icon } from 'components/Atoms/Icon/Icon';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from '../Timeline.module.scss';

export function ProgressFuture() {
  const { t } = useTranslation();
  return (
    <div className={classNames(styles.progress, styles.future)}>
      <Icon height={24} width={24} name="dots-horizontal" color="#D8D8D8" ariaLabel={t('icons.future')} />
    </div>
  );
}
